// lazyLoadImages.js start

export default function lazyLoadImages() {
  const images = document.querySelectorAll('img[data-src]');
  if (!('IntersectionObserver' in window)) {
    // Fallback: just load all images
    images.forEach(img => {
      img.src = img.dataset.src;
      img.classList.add('lazy-loaded');
    });
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.add('lazy-loaded');
        obs.unobserve(img);
      }
    });
  }, {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0.01
  });

  images.forEach(img => {
    observer.observe(img);
  });
}

// Lazy load HubSpot form script when .unlock section enters viewport
export function lazyLoadHubspotForm() {
  const formContainer = document.querySelector('.hubspot-form');
  if (!formContainer || !('IntersectionObserver' in window)) return;

  let loaded = false;
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !loaded) {
        loaded = true;
        // Dynamically load the external script
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
        script.onload = () => {
          if (window.hbspt && window.hbspt.forms) {
            window.hbspt.forms.create({
              portalId: "26632421",
              formId: "b0dc4304-15ca-4e00-bd9d-fbdbcc19cbfb",
              region: "eu1",
              target: '.hubspot-form'
            });
          }
        };
        document.body.appendChild(script);
        obs.unobserve(formContainer);
      }
    });
  }, { threshold: 0.1 });
  observer.observe(formContainer);
}

// lazyLoadImages.js end
